(() => {
  const STORAGE_KEY = "ezupCompare";

  const readList = () => {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(value) ? value : [];
    } catch (error) {
      return [];
    }
  };

  const writeList = (list) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      // Storage can be unavailable (private mode); the bar still works for this page.
    }
  };

  const bar = document.querySelector("[data-product-compare-bar]");
  if (!bar) return;

  const max = parseInt(bar.getAttribute("data-compare-max"), 10) || 4;
  const itemsElement = bar.querySelector("[data-compare-items]");
  const countElement = bar.querySelector("[data-compare-count]");
  const toggle = bar.querySelector("[data-compare-toggle]");
  const removeLabel = itemsElement.getAttribute("data-remove-label") || "Remove";
  const loading = document.querySelector("[data-compare-loading]");
  const LOADING_MS = 700;

  const setOpen = (open) => {
    bar.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", String(open));
  };

  const render = () => {
    const list = readList();
    countElement.textContent = list.length;
    itemsElement.innerHTML = "";

    list.forEach((item) => {
      const tile = document.createElement("div");
      tile.className = "product-compare-bar__item";

      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "product-compare-bar__remove";
      remove.setAttribute("aria-label", removeLabel);
      remove.textContent = "✕";
      remove.addEventListener("click", () => {
        writeList(readList().filter((entry) => entry.handle !== item.handle));
        render();
      });

      const link = document.createElement("a");
      link.href = item.url;
      if (item.image) {
        const image = document.createElement("img");
        image.src = item.image;
        image.alt = "";
        image.loading = "lazy";
        link.appendChild(image);
      }
      const name = document.createElement("span");
      name.className = "product-compare-bar__item-name";
      name.textContent = item.title;
      link.appendChild(name);

      tile.appendChild(remove);
      tile.appendChild(link);
      itemsElement.appendChild(tile);
    });

    if (list.length) {
      bar.hidden = false;
      requestAnimationFrame(() => bar.classList.add("is-visible"));
    } else {
      bar.classList.remove("is-visible", "is-open");
      toggle.setAttribute("aria-expanded", "false");
      bar.hidden = true;
    }
  };

  toggle.addEventListener("click", () => {
    setOpen(!bar.classList.contains("is-open"));
  });

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-compare-add]");
    if (!button) return;
    event.preventDefault();

    const item = {
      handle: button.getAttribute("data-compare-handle"),
      title: button.getAttribute("data-compare-title"),
      image: button.getAttribute("data-compare-image"),
      url: button.getAttribute("data-compare-url"),
    };
    if (readList().some((entry) => entry.handle === item.handle)) return;

    if (loading) loading.hidden = false;
    window.setTimeout(() => {
      const list = readList();
      list.push(item);
      while (list.length > max) list.shift();
      writeList(list);
      render();
      setOpen(true);
      if (loading) loading.hidden = true;
    }, LOADING_MS);
  });

  window.addEventListener("storage", (event) => {
    if (event.key === STORAGE_KEY) render();
  });

  render();
  window.ezupCompare = { readList, writeList, render };
})();
